// Semantic dark-mode colors for legacy inline styles. Each use keeps its original
// light-mode color as the CSS variable fallback. Filled badges keep white text.
export const darkAppearanceVariables: Record<string, string> = {
  "--app-surface-neutral": "#18251e",
  "--app-surface-green": "#163627",
  "--app-surface-blue": "#172e43",
  "--app-surface-purple": "#30203e",
  "--app-surface-pink": "#3c2332",
  "--app-surface-orange": "#382c1c",
  "--app-surface-red": "#3b2326",
  "--app-ink-neutral": "#e2e8e4",
  "--app-ink-green": "#99dfb0",
  "--app-ink-blue": "#94ceff",
  "--app-ink-purple": "#d7b4ff",
  "--app-ink-pink": "#ffb2d4",
  "--app-ink-orange": "#ffd08a",
  "--app-ink-red": "#ffb4b4",
  "--app-border": "#516258"
};

// Night keeps tinted legacy panels deeper than Dark while preserving contrast.
export const nightAppearanceVariables: Record<string, string> = {
  ...darkAppearanceVariables,
  "--app-surface-neutral": "#0d1a11",
  "--app-surface-green": "#10281b",
  "--app-surface-blue": "#102233",
  "--app-surface-purple": "#23172e",
  "--app-surface-pink": "#2c1924",
  "--app-surface-orange": "#2a2013",
  "--app-surface-red": "#2c191c",
  "--app-ink-neutral": "#f2fff4",
  "--app-border": "#31503b"
};

// Data-driven accents retain their hue. The variable fallback makes the mix
// equal to the original color in light mode; dark mode blends in readable ink.
export const adaptiveInk = (color: string) =>
  `color-mix(in srgb, ${color} 35%, var(--app-ink-neutral, ${color}) 65%)`;
export const adaptiveSurface = (color: string) =>
  `color-mix(in srgb, ${color} 15%, var(--app-surface-neutral, ${color}) 85%)`;

// Palette values are also consumed by MUI's JavaScript color utilities, which
// cannot parse CSS color-mix(). Resolve brand surfaces to opaque hex colors.
export const blendHexColors = (foreground: string, background: string, weight: number) => {
  const channels = [1, 3, 5].map(offset => {
    const front = parseInt(foreground.slice(offset, offset + 2), 16);
    const back = parseInt(background.slice(offset, offset + 2), 16);
    return Math.round(front * weight + back * (1 - weight)).toString(16).padStart(2, '0');
  });
  return `#${channels.join('')}`;
};
